"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationModule = void 0;
const axios_1 = require("axios");
class LocationModule {
    _formatAddress(address) {
        const root = address.results[0];
        return {
            street: root.address_components[1].long_name,
            country: root.address_components[5].short_name,
            city: root.address_components[3].long_name,
            state: root.address_components[4].short_name,
            neighborhood: root.address_components[2].short_name,
            cep: root.address_components[6].long_name,
            formatted_address: root.formatted_address,
        };
    }
    getCurrentAddress(latitude, longitude) {
        return axios_1.default
            .get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyB5tXrkiapXmzmvkkW0-7MQvfx1LL9VScQ`)
            .then(({ data: address }) => this._formatAddress(address));
    }
}
exports.LocationModule = LocationModule;
//# sourceMappingURL=location.js.map